const useLoggedInUser = () => {
  const loggedIn:any = localStorage.getItem('__session_polac_physical')
  return loggedIn ? JSON.parse(loggedIn) : null
}
export default useLoggedInUser
